/**
 * Fachliche Kerntypen. Diese Typen werden von Server (Drizzle-Schema),
 * Client (Dexie) und Berechnungslogik gemeinsam verwendet.
 *
 * Alle Maße sind Meter, alle Flächen Quadratmeter, jeweils als `number`.
 * Alle Zeitstempel sind ISO-8601-Strings in UTC.
 */
// ---------------------------------------------------------------------------
// Benutzer
// ---------------------------------------------------------------------------
/** `field` = Person A (Außendienst), `office` = Person B (Büro). */
export const USER_ROLES = ['field', 'office'];
export const USER_ROLE_LABELS = {
    field: 'Außendienst',
    office: 'Büro',
};
// ---------------------------------------------------------------------------
// Auftragsstatus
// ---------------------------------------------------------------------------
export const ORDER_STATUSES = ['neu', 'aufnahme_laeuft', 'aufnahme_fertig', 'erledigt'];
export const ORDER_STATUS_LABELS = {
    neu: 'Neu',
    aufnahme_laeuft: 'Aufnahme läuft',
    aufnahme_fertig: 'Aufnahme fertig',
    erledigt: 'Erledigt',
};
/** Status, die Person A (Außendienst) selbst setzen darf. */
export const FIELD_SETTABLE_STATUSES = ['neu', 'aufnahme_laeuft', 'aufnahme_fertig'];
// ---------------------------------------------------------------------------
// Bereichstypen
// ---------------------------------------------------------------------------
export const AREA_TYPES = [
    // Innen
    'maler_tapezier',
    'kreativtechnik',
    'lackierarbeiten',
    'schimmelsanierung',
    'innenputz',
    // Außen
    'fassadengestaltung',
    'fassadenbeschriftung',
    'dachsanierung',
    'waermedaemmung',
    // Sonstiges
    'sonstiges',
];
export const AREA_CATEGORIES = ['innen', 'aussen', 'sonstiges'];
// ---------------------------------------------------------------------------
// Aufmaß
// ---------------------------------------------------------------------------
/**
 * `room`    – Automatische Raumberechnung aus Länge/Breite/Höhe.
 * `surface` – Einzelne Wand-/Decken-/Bodenfläche.
 */
export const MEASUREMENT_KINDS = ['room', 'surface'];
export const SURFACE_TYPES = ['wand', 'decke', 'boden', 'sonstige'];
export const SURFACE_TYPE_LABELS = {
    wand: 'Wand',
    decke: 'Decke',
    boden: 'Boden',
    sonstige: 'Sonstige Fläche',
};
export const DEDUCTION_KINDS = ['fenster', 'tuer', 'sonstiges'];
export const DEDUCTION_KIND_LABELS = {
    fenster: 'Fenster',
    tuer: 'Tür',
    sonstiges: 'Sonstiger Abzug',
};
/** Grafische Vorlagen für das Fassaden-Aufmaß (Version 1: nur feste Vorlagen). */
export const FACADE_TEMPLATES = ['rechteck', 'traufseite', 'giebelseite'];
export const FACADE_TEMPLATE_LABELS = {
    rechteck: 'Rechteckige Fläche',
    traufseite: 'Traufseite',
    giebelseite: 'Giebelseite',
};
export const NOTE_TARGETS = ['order', 'area'];
//# sourceMappingURL=types.js.map